import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "panel"
}
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", {
  for: "employeeuid",
  class: "form-label"
}, "Employee UID", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("All events for this user")
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", {
  for: "company",
  class: "form-label"
}, "Company UID", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("View company")
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", {
  for: "accountid",
  class: "form-label"
}, "Account ID", -1)
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", {
  for: "firstname",
  class: "form-label"
}, "FirstName", -1)
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", {
  for: "lastname",
  class: "form-label"
}, "LastName", -1)
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", {
  for: "email",
  class: "form-label"
}, "Email", -1)
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", {
  for: "phone",
  class: "form-label"
}, "Phone", -1)
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = /*#__PURE__*/_createVNode("label", { class: "form-label" }, "Suppress Events", -1)
const _hoisted_21 = { class: "form-check form-switch" }
const _hoisted_22 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "suppressed"
}, "Disable event processing for this employee", -1)
const _hoisted_23 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Departments: ")
const _hoisted_25 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Department ids: ")
const _hoisted_27 = {
  key: 2,
  class: "mb-3"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("label", {
  for: "tags",
  class: "form-label"
}, "Tags", -1)
const _hoisted_29 = {
  type: "submit",
  id: "save",
  class: "btn btn-primary"
}
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_block = _resolveComponent("error-block")
  const _component_router_link = _resolveComponent("router-link")
  const _component_BIconXLg = _resolveComponent("BIconXLg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h1", null, _toDisplayString(_ctx.msg), 1),
    _createVNode(_component_error_block, { errors: _ctx.errors }, null, 8, ["errors"]),
    (_ctx.employee.id)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("fieldset", null, [
            _createVNode("form", {
              id: 'employee_' + _ctx.employee.id,
              onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.callSave()), ["prevent"]))
            }, [
              _createVNode("div", _hoisted_3, [
                _hoisted_4,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "employeeuid",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.employee.EmployeeUId = $event)),
                  disabled: _ctx.employee.id != ':'
                }, null, 8, ["disabled"]), [
                  [
                    _vModelText,
                    _ctx.employee.EmployeeUId,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (_ctx.employee.id != ':')
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: '/sheqsy/event?f.EmployeeUId='+_ctx.employee.EmployeeUId,
                      class: "btn btn-outline-primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_6, [
                _hoisted_7,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "company",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.employee.CompanyUId = $event)),
                  disabled: _ctx.employee.id != ':'
                }, null, 8, ["disabled"]), [
                  [
                    _vModelText,
                    _ctx.employee.CompanyUId,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (_ctx.employee.CompanyUId != ':')
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: '/sheqsy/company/'+_ctx.employee.CompanyUId,
                      class: "btn btn-outline-primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_9, [
                _hoisted_10,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "accountid",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.employee.ReferenceId = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.employee.ReferenceId,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "firstname",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.employee.FirstName = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.employee.FirstName,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "lastname",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.employee.LastName = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.employee.LastName,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createVNode("div", _hoisted_15, [
                _hoisted_16,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "email",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.employee.Email = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.employee.Email,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createVNode("div", _hoisted_17, [
                _hoisted_18,
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "phone",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.employee.PhoneNumber = $event))
                }, null, 512), [
                  [
                    _vModelText,
                    _ctx.employee.PhoneNumber,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createVNode("div", _hoisted_19, [
                _hoisted_20,
                _createVNode("div", _hoisted_21, [
                  _withDirectives(_createVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    id: "suppressed",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.employee.Suppressed = $event))
                  }, null, 512), [
                    [
                      _vModelCheckbox,
                      _ctx.employee.Suppressed,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  _hoisted_22
                ])
              ]),
              (_ctx.employee.Departments?.length)
                ? (_openBlock(), _createBlock("div", _hoisted_23, [
                    _hoisted_24,
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.employee.Departments, (dept, idx) => {
                      return (_openBlock(), _createBlock("div", {
                        key: idx,
                        class: "input-group mb-3"
                      }, [
                        _createVNode("span", {
                          class: "input-group-text sm-3",
                          id: 'department-'+idx,
                          style: {"min-width":"2em"}
                        }, _toDisplayString(idx), 9, ["id"]),
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          "aria-describedby": 'department-'+idx,
                          class: "form-control",
                          id: 'department-'+idx+'-val',
                          "onUpdate:modelValue": ($event: any) => (_ctx.employee.Departments[idx] = $event)
                        }, null, 8, ["aria-describedby", "id", "onUpdate:modelValue"]), [
                          [
                            _vModelText,
                            _ctx.employee.Departments[idx],
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createVNode("button", {
                          type: "button",
                          class: "btn",
                          "aria-label": "Remove",
                          onClick: ($event: any) => (_ctx.employee.Departments.splice(idx, 1))
                        }, [
                          _createVNode(_component_BIconXLg)
                        ], 8, ["onClick"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.employee.DepartmentRefs?.length)
                ? (_openBlock(), _createBlock("div", _hoisted_25, [
                    _hoisted_26,
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.employee.DepartmentRefs, (dept, idx) => {
                      return (_openBlock(), _createBlock("div", {
                        key: idx,
                        class: "input-group mb-3"
                      }, [
                        _createVNode("span", {
                          class: "input-group-text sm-3",
                          id: 'department-'+idx,
                          style: {"min-width":"2em"}
                        }, _toDisplayString(idx), 9, ["id"]),
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          "aria-describedby": 'department-'+idx,
                          class: "form-control",
                          id: 'department-'+idx+'-val',
                          "onUpdate:modelValue": ($event: any) => (_ctx.employee.DepartmentRefs[idx] = $event)
                        }, null, 8, ["aria-describedby", "id", "onUpdate:modelValue"]), [
                          [
                            _vModelText,
                            _ctx.employee.DepartmentRefs[idx],
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createVNode("button", {
                          type: "button",
                          class: "btn",
                          "aria-label": "Remove",
                          onClick: ($event: any) => (_ctx.employee.DepartmentRefs.splice(idx, 1))
                        }, [
                          _createVNode(_component_BIconXLg)
                        ], 8, ["onClick"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.employee.Tags?.length)
                ? (_openBlock(), _createBlock("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode("ul", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.employee.Tags, (tag, index) => {
                        return (_openBlock(), _createBlock("li", { key: index }, _toDisplayString(tag), 1))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("button", _hoisted_29, _toDisplayString((_ctx.employee.id == ':') ? 'create' : 'save'), 1),
              _hoisted_30,
              (_ctx.employee.id != ':')
                ? (_openBlock(), _createBlock("button", {
                    key: 3,
                    class: "btn btn-outline-danger",
                    onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.callDelete()), ["prevent"]))
                  }, "delete"))
                : _createCommentVNode("", true)
            ], 40, ["id"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}